export default class CookieNotice {
    constructor() {
        if (CookieNotice.initialized || ! window.tarteaucitron) {
            return;
        }

        CookieNotice.initialized = true;

        const consentManager = window.tarteaucitron;

        this.allowVimeo = this.allowVimeo.bind(this);
        this.blockVimeo = this.blockVimeo.bind(this);

        document.addEventListener('vimeo_loaded', this.allowVimeo);
        document.addEventListener('vimeo_allowed', this.allowVimeo);
        document.addEventListener('vimeo_disallowed', this.blockVimeo);

        consentManager.init({
            "privacyUrl": `${privacyUrl}`, /* Privacy policy url */
            "bodyPosition": "bottom", /* or top to bring it as first element for accessibility */

            "hashtag": "#cookies", /* Open the panel with this hashtag */
            "cookieName": "wkj_cookie", /* Cookie name */

            "orientation": "popup", /* Banner position (top - bottom - middle - popup) */

            "groupServices": false, /* Group services by category */
            "showDetailsOnClick": true, /* Click to expand the description */
            "serviceDefaultState": "wait", /* Default state (true - wait - false) */

            "showAlertSmall": false, /* Show the small banner on bottom right */
            "showTitleBanner": false, /* Also show the title (middleBarHead) on the top/bottom banners */
            "cookieslist": false, /* Show the cookie list in a mini banner */
            "cookieslistEmbed": false, /* Show the cookie list on the control panel */

            "showIcon": false, /* Show cookie icon to manage cookies */
            // "iconSrc": "", /* Optional: URL or base64 encoded image */
            "iconPosition": "BottomRight", /* Position of the icon between BottomRight, BottomLeft, TopRight and TopLeft */

            "adblocker": false, /* Show a Warning if an adblocker is detected */

            "DenyAllCta" : true, /* Show the deny all button */
            "AcceptAllCta" : true, /* Show the accept all button when highPrivacy on */
            "highPrivacy": true, /* HIGHLY RECOMMANDED Disable auto consent */
            "alwaysNeedConsent": false, /* Ask the consent for "Privacy by design" services */

            "handleBrowserDNTRequest": false, /* If Do Not Track == 1, disallow all */

            "removeCredit": true, /* Remove credit link */
            "moreInfoLink": true, /* Show more info link */
            "useExternalCss": false, /* If false, the tarteaucitron.css file will be loaded */
            "useExternalJs": false, /* If false, the tarteaucitron.services.js file and lang files will be loaded */

            // "cookieDomain": ".my-multisite-domaine.fr", /* Shared cookie for subdomain website */

            "readmoreLink": "", /* Change the default readmore link pointing to tarteaucitron.io */

            "mandatory": false, /* Necessary cookies do not need an opt-in control */
            "mandatoryCta": false,

            // "customCloserId": "", /* Optional a11y: Custom element ID used to open the panel */

            "googleConsentMode": true, /* Enable Google Consent Mode v2 for Google ads and GA4 */
            "bingConsentMode": true, /* Enable Bing Consent Mode for Clarity and Bing Ads */
            "pianoConsentMode": true, /* Enable Piano Analytics Consent Mode */
            "pianoConsentModeEssential": false, /* Load in Essential mode instead of opt-out by default */
            "softConsentMode": false, /* Soft consent mode (consent is required to load the services) */

            "dataLayer": false, /* Send an event to dataLayer with the services status */
            "serverSide": false, /* Server side only, tags are not loaded client side */

            "partnersList": false /* Details the number of partners on the popup and middle banner */
        });

        consentManager.job = consentManager.job || [];

        if (consentManager.job.indexOf('vimeo') === -1) {
            consentManager.job.push('vimeo');
        }
    }

    /**
     * Insert Vimeo URLs only after the visitor has explicitly consented.
     */
    allowVimeo() {
        document.querySelectorAll('iframe[data-vimeo-src]').forEach(($iframe) => {
            if ( ! $iframe.getAttribute('src')) {
                const autoplay = $iframe.dataset.vimeoAutoplay === '1';
                const embedUrl = this.getVimeoEmbedUrl($iframe.dataset.vimeoSrc, autoplay);

                if (embedUrl) {
                    $iframe.setAttribute('src', embedUrl);
                }
            }
        });

        document.dispatchEvent(new Event('vimeo-consent-granted'));
    }

    /**
     * Convert both regular and player Vimeo URLs to a valid, privacy-friendly
     * iframe URL. CMS users should not have to enter the embed URL themselves.
     */
    getVimeoEmbedUrl(url, autoplay = false) {
        let parsedUrl;

        try {
            parsedUrl = new URL(url, window.location.origin);
        } catch (error) {
            return null;
        }

        const isVimeoEmbed = parsedUrl.hostname === 'player.vimeo.com'
            && parsedUrl.pathname.indexOf('/video/') === 0;

        if ( ! isVimeoEmbed) {
            const pathParts = parsedUrl.pathname.split('/').filter(Boolean);
            const videoId = pathParts.find((part) => /^\d+$/.test(part));

            if ( ! videoId) {
                return null;
            }

            const videoIdIndex = pathParts.indexOf(videoId);
            const pathHash = pathParts[videoIdIndex + 1];
            const hash = parsedUrl.searchParams.get('h')
                || (pathHash && ! /^\d+$/.test(pathHash) ? pathHash : null);

            parsedUrl = new URL(`https://player.vimeo.com/video/${videoId}`);

            if (hash) {
                parsedUrl.searchParams.set('h', hash);
            }
        }

        parsedUrl.searchParams.set('autoplay', autoplay ? '1' : '0');
        parsedUrl.searchParams.set('muted', '1');
        parsedUrl.searchParams.set('controls', '0');
        parsedUrl.searchParams.set('loop', '0');
        parsedUrl.searchParams.set('playsinline', '1');
        parsedUrl.searchParams.set('dnt', '1');

        return parsedUrl.toString();
    }

    /**
     * Stop Vimeo and remove its network-bearing iframe URLs when consent is denied.
     */
    blockVimeo() {
        document.querySelectorAll('iframe[data-vimeo-src], iframe[data-vimeo-lightbox-player]').forEach(($iframe) => {
            if ($iframe.player) {
                const unload = $iframe.player.unload();

                if (unload && typeof unload.catch === 'function') {
                    unload.catch(() => {});
                }

                $iframe.player = null;
            }

            $iframe.removeAttribute('src');
        });

        document.dispatchEvent(new Event('vimeo-consent-revoked'));
    }
}

CookieNotice.initialized = false;
